// // middleware/RootGate.jsx
// import { Navigate } from "react-router";
// import Cookies from "js-cookie";
// import Home from "app/publicpages/Home";

// export default function RootGate() {
//   const accessToken = Cookies.get("access_token");
//   const email = Cookies.get("email");
//   const userid = Cookies.get("userid");

//   const isValidSession = !!accessToken && !!email && !!userid;

//   if (isValidSession) {
//     return <Navigate to="/raajneeti/home" replace />;
//   }

//   return <Home />;
// }


import Home from "app/publicpages/Home";


export default function RootGate() {
  return <Home />;
}